import { useTranslations } from 'next-intl';
import { Image } from 'components/image';
import { CatHeading } from 'components/blocks-components';
import { NO_EXACT_MATCH_IMAGE_SIZE } from '../../../../_constants/constants';
import { NO_EXACT_MATCH_IMAGE } from 'constants/common';

export const NoEquipmentSearchResult = () => {
  const t = useTranslations();
  const { src, alt } = NO_EXACT_MATCH_IMAGE;
  const { width, height } = NO_EXACT_MATCH_IMAGE_SIZE;

  return (
    <div className="d-flex flex-column justify-content-center align-items-center mt-4">
      <Image src={src} alt={alt} width={width} height={height} />
      <CatHeading variant="label-lg" className="mt-2">
        <span className="u-color--Black">{t('MEQ_NO_EXACT_MATCH')}</span>
      </CatHeading>
    </div>
  );
};
